import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-767a80e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "member-remove-wrap" }
const _hoisted_2 = { class: "member-remove__tips" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("移除")


export default /*#__PURE__*/_defineComponent({
  __name: 'removeMember',
  props: {
    name: null
  },
  setup(__props: any) {

const props = __props as {
  name: string
}



return (_ctx: any,_cache: any) => {
  const _component_NButton = _resolveComponent("NButton")!
  const _component_NSpace = _resolveComponent("NSpace")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " 是否将 【" + _toDisplayString(props.name) + "】 从当前团队空间中移除？ ", 1),
    _createVNode(_component_NSpace, {
      class: "member-remove__footer",
      size: 16,
      justify: "end"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_NButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_NButton, {
          type: "error",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})